import React, { useEffect, useState } from 'react';
import { RxOrder } from 'openapi';
import CommonContainer from "../../containers/Common";
import RxOrderContainer from "../../containers/RxOrder";
import RxOrderList from '../lists/RxOrderList';

const Root = (() => {
  const commonContainer = CommonContainer.useContainer();
  const rxOrderContainer = RxOrderContainer.useContainer();

  const now = new Date();
  const utc = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date(utc));

  useEffect(() => {
    (handleReload)();
  }, [selectedDate]);

  const handleSelectedDateChange = (date: Date | null) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const handleOrder = async (rxOrder: RxOrder) => {
    setIsLoading(true);
    await rxOrderContainer.order({
      requests: rxOrder
    });
    setIsLoading(false);
  }

  const handleReload = async () => {
    setIsLoading(true);
    rxOrderContainer.setRxOrders([]);
    await commonContainer.loadMakers();
    await commonContainer.loadFrames();
    await rxOrderContainer.loadColors();
    await rxOrderContainer.load(selectedDate);
    setIsLoading(false);
  }

  return (
    <RxOrderList
      date={selectedDate}
      onSelectedDateChange={handleSelectedDateChange}
      onOrder={handleOrder}
      onReload={handleReload}
      isLoading={isLoading}
      rxOrders={rxOrderContainer.rxOrders}
    />
  )
}) as React.FC;

export default (() => {
  return (
    <RxOrderContainer.Provider>
      <Root />
    </RxOrderContainer.Provider>
  )
}) as React.FC;
